import React from "react";
import "./Loader.css";

export default function Loader() {
    return (
        <div className="loader-container">
            <div className="spinner-container">
                <div className="loading-spinner">
                    <div className="loading-spinner2">
                    </div>
                </div>
            </div>
        </div>
        
        // <div className="loader-container">
        //     <div className="progressIndicator"></div>
        // </div>

    );
}